// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2TtRF","col":"styles_col__2G5L0","fulfillmentStatus":"styles_fulfillmentStatus__2s33H","emailCol":"styles_emailCol__3aLUr"};